import { is } from 'stdlib/is'

import { Number } from 'stdlib/Number'

import DOM from '@common/DOM/DOM'

import pinchPreventer from './pinchPreventer'

const MAX_WAIT_BETWEEN_TOUCHES = 200

/**
 * Zoomolás és Multitouch letiltása touch eszközön, az adott elemre.
 * @see {@link https://exceptionshub.com/disable-double-tap-zoom-option-in-browser-on-touch-devices.html}
 * @param query - Az elem amire vonatkozik.
 */
export default function preventMultiTouch (query: string): void {
  const el = document.querySelector(query)

  if (!el) {
    return
  }

  // Legjobb, ha start-ra és move-ra is rá van kötve
  el.addEventListener('touchstart', pinchPreventer, { passive: false })
  el.addEventListener('touchmove', pinchPreventer, { passive: false })

  // Touch end esetén sima és dupla klikk kezelés
  el.addEventListener('touchend', (e: Event) => {
    if (e.cancelable) {
      e.preventDefault()
    }

    const fingers = (e as TouchEvent).touches.length

    if (fingers > 0) {
      return
    }

    // Ha a vizsgált elem nem HTMLElement.
    if (!is.instanceOf(e.target, HTMLElement)) {
      return
    }

    // Előző touch, ha volt
    const { lastTouch } = e.target.dataset
    // Aktuális idő
    const t2 = e.timeStamp
    // Előző idő
    const t1 = lastTouch ? Number.parse(lastTouch) : t2
    // Két idő különbsége
    const dt = t2 - t1
    // Elmentjük ezt az időt
    e.target.dataset.lastTouch = t2.toString()

    // Nincs idő vagy túlléptük az időt
    if (!dt || dt > MAX_WAIT_BETWEEN_TOUCHES) {
      e.target.click()

      return
    }
    // Egyébként duplaklikk

    DOM.dispatch(e.target, 'dblclick', true)
  })
}
